import type { SWRConfiguration } from 'swr'

/**
 * Global SWR retry configuration with exponential backoff.
 *
 * Retries up to 3 times (at 3s, 6s, 12s). Skips retries for 4xx errors.
 *
 * Note: after all retries are exhausted, SWR may restart the cycle when
 * the user returns to the tab (revalidateOnFocus) or regains network
 * (revalidateOnReconnect). To disable this, add those flags to this config.
 */
export const swrRetryConfig: Pick<SWRConfiguration, 'onErrorRetry'> = {
  onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
    if (error?.status >= 400 && error?.status < 500) return
    if (retryCount >= 3) return
    setTimeout(() => revalidate({ retryCount }), 3000 * 2 ** retryCount)
  },
}
